import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    categoryBusinesses: [],
};

const getters = {
    categoryBusinesses: state => state.categoryBusinesses,
};

const mutations = {
    setCategoryBusinesses(state, data) {
        state.categoryBusinesses = data;
    },
};

const actions = {
    async getCategoryBusinesses({ commit, dispatch }) {
        let route = Laroute.route('franchise.vue.categoryBusiness');

        startLoading(dispatch, 'categoryBusiness');

        return axios
            .get(route)
            .then(res => {
                commit('setCategoryBusinesses', res.data);
                endLoading(dispatch, 'categoryBusiness');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'categoryBusiness');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/categoryBusiness.js